module.exports = __webpack_public_path__ + "img/dupont-green.4228b735.svg";